// 按页面划分
export default {
    // 公共页面
    common: {
        title: "ສູນຂໍ້ມູນ",
        pull_refresh: "ດຶງລົງເພື່ອເຮັດໃຫ້ສົດຊື່ນ",
        release_refresh: "ປ່ອຍໃຫ້ Refresh",
        refresh_loading: "ກໍາລັງໂຫລດ ...",
        footer_text: "ການບໍລິການຖືກສະເຫນີໂດຍ Ucloudlink (NASDAQ: UCL)"
    },
    home: {
        input_placeholder: "ປະເທດຫຼືພາກພື້ນ",
        my_flow: "ຂໍ້ມູນຂອງຂ້ອຍ",
        charge_code: "ຕື່ມເງິນລະຫັດ",
        coupons: "ຄູປອງ",
        local_package: "ຂໍ້ມູນທ້ອງຖິ່ນ",
        more: "ຫຼາຍ",
        popular_destination: "ປະເທດ / ພາກພື້ນ",
        buy_now: "ຊື້ດຽວນີ້",
        package_useing: "ເຄື່ອນໄຫວ",
        unused: 'មិនເຄື່ອນໄຫວ',
        download_app: "ດາວໂຫລດ APP",
        enter_the_mall_list: "ເຂົ້າສູ່ລາຍການສູນການຄ້າ",
        no_data: "ບໍ່ມີຂໍ້ມູນ",
        no_data_available: 'ບໍ່ມີຂໍ້ມູນ',
        copy_success: "ສຳເລັດການຄັດລອກ",
        copy_fail: "ການຄັດລອກລົ້ມເຫລວ",
        meritsTitle: 'ຜົນປະໂຫຍດແມ່ນຫຍັງ？',
        merits1: 'ບໍ່ຈຳເປັນຕ້ອງໃຊ້ SIM & ບໍ່ມີຄ່າໃຊ້ຈ່າຍຕໍ່ເດືອນ',
        merits2: 'ລວມເຊບອອເປີເຈເຕີເທິບ 2-3 ຊັ້ນນໍາ ເພື່ອປ່ຽນປະຕິບັດເຄືອຂາຍອັດຕโนມັດ',
        go_buy: "ໄປຊື້",
        instant_savings: "ປະຫຍອມ",
        expires_in: "ໝົດອາຍຸໃນ",
        download_app_tips: "ດາວໂຫຼດແອັບ ເພື່ອຮັບຂໍ້ສະເໜີ ແລະ ປະສົບການເພີ່ມເຕີມ"
    },
    packages: {
        sub_title: {
            us: "ບໍ່ລວມ gam, saipan",
            it: "ລວມທັງເມືອງວາຕິກັນ, San Marino",
            va: "ລວມທັງອິຕາລີ, San Marino",
            sm: "ລວມທັງອິຕາລີ, ເມືອງວາຕິກັນ",
            ma: "ລວມທັງ Sahara ຕາເວັນຕົກ",
            eh: "ລວມທັງ morocco",
            ch: "ລວມທັງ lychtenstein",
            li: "ລວມທັງສະວິດເຊີແລນ",
            fr: "ລວມທັງ Monaco",
            mc: "ລວມທັງປະເທດຝຣັ່ງ",
            fi: "ລວມທັງເກາະດອນຍົນ",
            ax: "ລວມທັງຟິນແລນ",
            gu: "ລວມທັງໃນພາກເຫນືອຂອງເກາະ Mariana",
            mp: "ລວມທັງ guam"
        },
        unlimited_packages: "ຊຸດຂໍ້ມູນບໍ່ຈໍາກັດ",
        normal_packages: "ຊຸດຂໍ້ມູນທໍາມະດາ",
        multi_region_packages: "ຫຼາຍພາກພື້ນ",
        regional_data: "ຂໍ້ມູນພื้นที่",
        high_speed_text: "ຂໍ້ມູນຄວາມໄວສູງ",
        infiniteFlow: "ຂໍ້ມູນທີ່ບໍ່ຈໍາກັດ",
        unLimitData: 'ບໍ່ຈຳກັດ',
        high_speed_text_year: "ຄວາມໄວສູງສຸດ / MP",
        package_list: "ລາຍການແພັກເກດ",
        special_offer: 'ຂາຍລາຄາຖ່າຍ',
        first_month: 'ເດືອນ ທຳອິດ',
        periodUnit: {
            day: "ກາງເວັນ",
            month: "ເດືອນ",
            hour: "ຊົ່ວໂມງ",
            year: "ປີ"
        },
        periodUnits: {
            day: "ກາງເວັນ",
            month: "ເດືອນ້ວ",
            hour: "ຊົ່ວໂມງ",
            year: "ປີ"
        },
        periodUnitSimp: {
            day: "ວ",
            month: "ສໍາລັບ",
            hour: "ມ",
            year: "ໄດ້"
        },
        periodUnitMonthly:'ແຕ່ລະເດືອນ',
        periodUnitsSimp: {
            day: "ວ",
            month: "ສໍາລັບ",
            hour: "ມ",
            year: "ໄດ້"
        },
        unlimited_good_name: {
            day: "ມື້ຜ່ານ",
            month: "ຜ່ານປະຈໍາເດືອນ",
            year: "ຜ່ານໄປປະຈໍາປີ"
        },
        continuousMonth: "ເດືອນຕໍ່ມາ",
        continuousDay: "ມື້ຕໍ່ເນື່ອງ",
        continuousYear: "ຕະຫລອດ",
        day_invalid: "ຫມົດອາຍຸໃນມື້ປະຈຸບັນ",
        month_invalid: "ຫມົດອາຍຸໃນເດືອນປະຈຸບັນ",
        immediate_valid: "ມີປະສິດຕິຜົນໃນທັນທີ",
        tomorrow_day_valid: "ມີປະສິດທິຜົນຕັ້ງແຕ່ມື້ຕໍ່ມາ",
        tomorrow_month_valid: "ມີປະສິດທິຜົນຕັ້ງແຕ່ເດືອນຕໍ່ໄປ",
        detail: {
            cell_flow: "ຂໍ້ມູນ",
            cell_period: "ຄວາມຖືກຕ້ອງ",
            buy_quantity: "ຈໍານວນ",
            use_area: "ການຄຸ້ມຄອງ",
            use_intro: "ຂໍ້ກໍານົດແລະເງື່ອນໄຂ",
            buy_btn: "ການສັ່ງຊື້",
            pay: "ຈ່າຍເງິນ",
            buy_tips: 'ເຈົ້າກຳລັງໃຊ້ແພັກເກັດ %@packageName ຢູ່ តើ​ເຈົ້າຕ້ອງການ຋ื้อແພັກເກັດນີ້ບໍ？',
            haveOrderTips: "ໄດ້ສ້າງການສັ່ງຊື້ທີ່ລໍຖ້າຈ່າຍເງິນແລ້ວ ກົດຢືນຢັນທີ່ຈະໄປຫນ້າຂໍ້ມູນຂອງຂ້ອຍ！"
        },
        confirm: {
            title: "ການຢືນຢັນຄໍາສັ່ງ",
            real_pay_amount: "ຈໍານວນເງິນທີ່ຈ່າຍ",
            online_payment: "ການຈ່າຍເງິນອອນໄລນ໌",
            create_order_error: "ການຕັ້ງຄ່າລົ້ມເຫລວ"
        }
    },
    pay: {
        result: {
            loading_order_status: 'ໄດ້ຮັບສະຖານະການສັ່ງຊື້ ...',
            buy_success: 'ຄໍາສັ່ງຄົບຖ້ວນ',
            buy_pending: 'ການຢືນຢັນທີ່ຍັງຄ້າງ',
            buy_pending_tip: 'ການຊໍາລະເງິນໃນຂະບວນການ ... ຖ້າການຈ່າຍເງິນບໍ່ໄດ້ຮັບການໂອນພາຍໃນ 10 ນາທີ, ກະລຸນາຕິດຕໍ່ຫາພວກເຮົາສໍາລັບການສະຫນັບສະຫນູນ.',
            get_payment_info_fail: 'ການຊື້ຂໍ້ມູນກ່ຽວກັບການຈ່າຍເງິນລົ້ມເຫລວ',
            cell_package: 'ຫໍ່',
            cell_buy_amount: 'ນິຍາຍ',
            cell_real_amount: 'ຈໍານວນເງິນທີ່ຈ່າຍ',
            go_to_order_btn: 'ໄປທີ່ຊຸດຂອງຂ້ອຍ',
            back_home: 'ກັບໄປເຮືອນ',
            back_mall: 'ກັບໄປທີ່ສູນການຄ້າ',
            ordersn_empty: 'ການສັ່ງຊື້ບໍ່ສາມາດຫວ່າງໄດ້',
            order_search_error: 'ຄວາມຜິດພາດທີ່ບໍ່ຄາດຄິດ',
            goodsName: 'ຊື່ຜະລິດຕະພັນ'
        },
        fail: {
            payment_fail: 'ການຈ່າຍເງິນລົ້ມເຫລວ',
            back_home: 'ກັບໄປເຮືອນ'
        }
    },
    CountryGroup: {
        title: 'ປະເທດ / ພາກພື້ນ',
        placeholder: 'ປະເທດຫຼືພາກພື້ນ',
        clear: 'ແຈ່ມແຈ້ງ',
        history: 'ປະຫວັດການຄົ້ນຫາ'
    },
    PromotionCode: {
        verification: {
            title: 'ຕື່ມເງິນລະຫັດ',
            minititle: 'ຕື່ມເງິນລະຫັດ',
            input: 'ກະລຸນາໃສ່ລະຫັດດ້ານເທິງ',
            explain: 'ເຄັດ​ລັບ​: ແຕະ​ທີ່​ປຸ່ມ​ສະ​ແກນ​ຢູ່​ດ້ານ​ຂວາ​ເທິງ​ເພື່ອ​ສະ​ແກນ QR ລະ​ຫັດ​ຂອງ​ບັດ​ບັດ​ປະ​ຈໍາ​ວັນ​, ຫຼື​ການ​ປ້ອນ​ລະ​ຫັດ​ໃບ​ຊໍາ​ລະ​ດ້ວຍ​ຕົນ​ເອງ (ຕົວ​ພິມ​ນ້ອຍ​) ຖ້າ​ຫາກ​ວ່າ​ມັນ​ບໍ່​ເຮັດ​ວຽກ​.',
            submit: 'ຍື່ນສະເຫນີ',
            exchange: 'ໄຖ່',
            cancel: 'ຍົກເລີກ',
            Inquiry: 'ທ່ານແນ່ໃຈບໍ່ທີ່ຈະແລກປ່ຽນ',
            ErrorCode: 'ຂໍ້ຜິດພາດຂອງລະຫັດເພີ່ມເຕີມ'
        },
        recharge_success: {
            package: 'ຫໍ່',
            content: 'ໄດ້ຮັບການໄຖ່ຢ່າງສໍາເລັດຜົນ',
            back: 'ກັບໄປທີ່ສູນການຄ້າ',
            view_packets: 'ໄປທີ່ຊຸດຂອງຂ້ອຍ'
        }
    },
    order: {
        state: {
            inUse: 'ໄດ້ເປີດໃຊ້ງານ',
            isFirst: 'ບຸພາບ',
            toFirst: 'ບຸລິມະສິດ',
            inactive: 'ບໍ່ໄດ້ເປີດໃຊ້ງານ'
        },
        periodUnits: {
            minute: 'ນາທີ (s)',
            hour: 'ຊົ່ວໂມງ',
            day: 'ກາງເວັນ',
            month: 'ເດືອນ (s)'
        },
        useIntro: {
            tip1: 'ຊຸດຂໍ້ມູນທີ່ບໍ່ຈໍາກັດມີບຸລິມະສິດສູງກ່ວາຊຸດຂໍ້ມູນປະລິມານ.',
            tip2: 'ຄວາມສໍາຄັນຂອງການນໍາໃຊ້ທີ່ໃຊ້ໃນວັນຊື້ສໍາລັບຊຸດດຽວກັນສໍາລັບຊຸດດຽວກັນກັບຊຸດດຽວກັນກັບວັນທີທີ່ຊື້ກ່ອນ, ໃນຂະນະທີ່ບູລິມະສິດຂອງແພັກເກດຂອງຊຸດດຽວແມ່ນສູງກວ່າຊຸດໃນພາກພື້ນ.',
            tip3: 'ນອກນັ້ນທ່ານຍັງສາມາດປັບບູລິມະສິດຂອງການໃຊ້ແພັກເກັດທີ່ໃຊ້ໃນປະເພດດຽວກັນ.'
        },
        myFlow: 'ຂໍ້ມູນຂອງຂ້ອຍ',
        remainingFlow: 'ຂໍ້ມູນທີ່ເຫລືອ',
        remainingTime: 'ຊ້າຍຊ້າຍ',
        remainingHighFlow: 'ຂໍ້ມູນຄວາມໄວສູງ',
        validPeriod: 'ຄວາມຖືກຕ້ອງ',
        noneFlow: 'ບໍ່ມີຊຸດຂໍ້ມູນ',
        noneFlowTip: 'ກະລຸນາຊື້ຊຸດຂໍ້ມູນແລະເພີດເພີນໄປກັບເຄືອຂ່າຍທີ່ມີຄຸນນະພາບສູງ',
        buyPackFlow: 'ຊື້ແພັກເກດ',
        checkInvalidFlow: 'ກວດເບິ່ງຊຸດຂໍ້ມູນທີ່ຫມົດອາຍຸ',
        orderList: {
            "title": "ຄໍາສັ່ງຂອງຂ້ອຍ",
            "amount_paid": "ທັງຫມົດ",
            "device": "ອຸປະກອນທີ່ເປັນເຈົ້າຂອງ",
            "order_details": "ລາຍລະອຽດການສັ່ງຊື້",
            "total_amont": "ນິຍາຍ",
            "orderSN": "ສັ່ງບໍ່.",
            "createTime": "ເວລາສ້າງ",
            "cancelTime": "ເວລາປິດ",
            "payTime": "ເວລາສັ່ງ",
            "unsubTime": "ຍົກເລີກເວລາ",
            "payMethod": "ວິທີການຊໍາລະເງິນ",
            "thirdSN": "ການເຮັດທຸລະກໍາບໍ່.",
            "delete": "ລົບ",
            "cancel": "ຍົກເລີກການສັ່ງຊື້",
            "unsub": "ການຈ່າຢເງິນ",
            "goto_cancel": "ທ່ານຕ້ອງການຍົກເລີກການສັ່ງຊື້ບໍ?",
            "goto_unsubscribe": "ທ່ານຕ້ອງການຍົກເລີກການສັ່ງຊື້ບໍ?",
            "delete_Tips": "ຄໍາສັ່ງບໍ່ສາມາດໄດ້ຮັບການກັບຄືນມາຫຼັງຈາກຖືກລຶບອອກ, ສະນັ້ນບັນຫາການບໍລິການຂອງທ່ານບໍ່ສາມາດຈັດການໄດ້.ທ່ານແນ່ໃຈບໍ່ທີ່ຈະລຶບມັນ?",
            "status_success": "ສໍາເວນ",
            "status_pending": "ບໍ່ໄດ້ຈ່າຍ",
            "status_cancel": "ປິດ",
            "status_unsub": "ຍົກເລີກ",
            "payMethod_stripe": "ບັດເຄຣດິດ"
          }
    },
    registerlogin: { 
        create_account_tip:"ສ້າງບັນຊີ, ເລີ່ມປະສົບການສະເພາະ",
        select_country_tip:"ອຸປະກອນໃຊ້ປະເທດ / ພາກພື້ນ",
        email_name: 'ຈົດຫມາຍຈົດຫມາຍ',
        phone_name: 'ໂທລະສັບ',
        email_address: 'ທີ່ຢູ່ອີເມວ',
        password: 'ລະຫັດຜ່ານ',
        country: 'ປະເທດ',
        select_country: 'ເລືອກປະເທດ',
        cancel: 'ຍົກເລີກ',
        confirm: 'ແນ່ໃຈ',
        please_enter: 'ກະລຸນາໃສ່ຕົວອັກສອນ 6-20 (ປະສົມປະສານຂອງຕົວອັກສອນ, ຕົວເລກຫຼືສັນຍາລັກ)', // Excel中无对应翻译
        select_country_tips: 'ການຄັດເລືອກປະເທດແມ່ນສໍາລັບການເບິ່ງຊຸດທ້ອງຖິ່ນ. ມັນບໍ່ສາມາດປ່ຽນແປງໄດ້ຫຼັງຈາກລົງທະບຽນ. ກະລຸນາຢືນຢັນ!',
        global_roaming: 'ລະຫັດໂດເມນສາກົນ',
        phone_number: 'ເບີໂທລະສັບ',
        agree: 'ຕົກລົງ',
        user_agreement: 'ຂໍ້ຕົກລົງຂອງຜູ້ໃຊ້',
        and: 'ແລະ',
        privacy_policy: 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
        register_login: 'ລົງທະບຽນຫຼືເຂົ້າສູ່ລະບົບ',
        login_error: "ຈໍານວນຂອງການເຂົ້າສູ່ແມ່ນເລື້ອຍໆເກີນໄປ, ກະລຸນາລອງໃຫມ່ໃນພາຍຫຼັງ!",
        register_error: "ຈໍານວນການລົງທະບຽນແມ່ນເລື້ອຍໆເກີນໄປ, ກະລຸນາລອງໃຫມ່ໃນພາຍຫຼັງ!",
        forgot_pwd: 'ລືມລະຫັດຜ່ານ',
        app_tips: 'ເຂົ້າສູ່ລະບົບແອັບ to ດ້ວຍບັນຊີນີ້ຫຼັງຈາກທີ່ດາວໂຫລດມັນເພື່ອເຂົ້າເຖິງຄຸນສົມບັດເພີ່ມເຕີມ.',
        download_app:'ໄປດາວໂຫລດ App',
        rememberPwd: 'ຈື່ລະຫັດຜ່ານ',
        third_login: "ສືບກັນ",
        agreement_tips: "ກະລຸນາກວດເບິ່ງຂໍ້ຕົກລົງຂອງຜູ້ໃຊ້ແລະກ່ອງນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
        selectCountry_tips: "ກະລຸນາໃຫ້ສັງເກດວ່າປະເທດທີ່ລົງທະບຽນຈະສົ່ງຜົນກະທົບຕໍ່ວິທີການຈ່າຍເງິນແລະສະກຸນເງິນຕໍ່ໄປນີ້ໂດຍກົງ, ກະລຸນາເລືອກຕາມຄວາມຕ້ອງການຂອງທ່ານ.",
        login_error_cancel: "ຜູ້ໃຊ້ໄດ້ຍົກເລີກການເຂົ້າສູ່ລະບົບ",
        login_error_auth: "ກະລຸນາອະນຸຍາດໃຫ້ປັອปອັບຈາກການຕັ້ງຄ່າບຣາວເຊີ",
        device_tips: "ອຸປະກອນລໍຖ້າເປີດໃຊ້ງານ. ດຳເນີນການພາຍໃນ 24 ຊົ່ວໂມງ"
    },
    forgotPwd: {
        forgot_pwd: 'ລືມລະຫັດຜ່ານ',
        email_address: 'ທີ່ຢູ່ອີເມວ',
        next: 'ຕໍ່ໄປ',
        email_has_been_sent: 'ພວກເຮົາໄດ້ສົ່ງອີເມວໄປຫາ %@email. ກະລຸນາຄລິກໃສ່ການເຊື່ອມຕໍ່ແລະປະຕິບັດຕາມຂັ້ນຕອນເພື່ອດຶງລະຫັດຜ່ານຂອງທ່ານ.',
        have_retrieved_it: 'ຂ້ອຍໄດ້ພົບເຫັນ',
        unable_to_receive_email: 'ບໍ່ສາມາດຮັບອີເມວໄດ້ບໍ? ກະລຸນາກວດເບິ່ງວ່າມີອີເມວຈາກ %@email ຢູ່ພາຍໃຕ້ສະແປມຂອງທ່ານແລະລຶບລາຍຊື່',
        or: 'ຫຼື',
        resend: 'ສົ່ງຄືນ',
        global_roaming: 'ລະຫັດໂດເມນສາກົນ',
        phone_number: 'ເບີໂທລະສັບ',
        verification_code_has_been_sent: 'ພວກເຮົາໄດ້ສົ່ງລະຫັດຢັ້ງຢືນໄປທີ່:',
        verification_code: 'ລະຫັດຢືນຢັນ',
        no_verification_code_received: 'ບໍ່ໄດ້ຮັບລະຫັດຢັ້ງຢືນບໍ?',
        please_enter: 'ກະລຸນາໃສ່ຕົວອັກສອນ 6-20 (ປະສົມປະສານຂອງຕົວອັກສອນ, ຕົວເລກຫຼືສັນຍາລັກ)', 
        reset_password: 'ຕັ້ງລະຫັດຜ່ານຄືນໃຫມ່',
        reset_successful: 'ປັບໃຫມ່ສໍາເລັດແລ້ວ'
    },
    coupons: {
        coupons_name: 'ຄູປອງ',
        no_coupons: 'ບໍ່ມີຄູປອງເທື່ອ',
        no_data: 'ບໍ່ມີຂໍ້ມູນເທື່ອ',
        applicable_to_the_following:'ຄູປອງແມ່ນເຫມາະສົມສໍາລັບຊຸດຂໍ້ມູນຕໍ່ໄປນີ້'
    },
    digital:{
        title:"ອຸປະກອນ sn",
        purchased:"ການຊື້ຂອງຂ້ອຍ",
        viewAll:"ຫຼາຍ",
        skinStore:"ຮ້ານຜະລິດຕະພັນ",
        completed:"ຊື້",
        goBuy:"ຊື້",
        order: {
          title:"ສັ່ງຊື້"
        },
        detail: {
          describe:"ລາຍລະອຽດ"
        }
    },
    viewPL: {
        other: 'ອື່ນ'
    },
    invalidFlow: {
        stateName: 'ສະຖານະພາບ',
        state: {
          NOT_ACTIVATED: "inactivated",
          IN_USING: "ມີໄວ້",
          USE_END: "ເມື່ອຍ",
          EXPIRE: "ຫມົດອາຍຸແລ້ວ",
          TRANSFER: "ການໂອນຍ້າຍ",
          UNSUBSCRIBE: "ຍົກເລີກ",
          VALID: "ຖືກຕ້ອງ",
          INVALID: "ບໍ່ເປັນຫຢັງ",
          EXCHANGE_POINTS: "ແລກປ່ຽນຈຸດ"
        },
        noneFlow: 'ບໍ່ມີຊຸດຂໍ້ມູນທີ່ຫມົດອາຍຸ',
        pageName: 'ຊຸດຂໍ້ມູນທີ່ຫມົດອາຍຸ'
    },
    flowDetail: {
        title: 'ລາຍລະອຽດຂໍ້ມູນ',
        flow: 'ຂໍ້ມູນ',
        validTime: 'ເລີ່ມຕົ້ນ',
        invalidTime: 'ຕ່ົນ່ວາ',
        coverage: 'ການຄຸ້ມຄອງ',
        useIntro: 'ຂໍ້ກໍານົດແລະເງື່ອນໄຂ',
        purchaseTime: 'ຊື້ຢູ່',
        subtotal: 'ນິຍາຍ',
        status: 'ສະຖານະພາບ',
        cancel: 'ຍົກເລີກ',
        buyAgain: 'ຊື້ອີກຄັ້ງ',
        validity: 'ຄວາມຖືກຕ້ອງ',
        tip: 'ແຈ້ງການ',
        cancelTip: 'ທ່ານແນ່ໃຈບໍ່ວ່າທ່ານຕ້ອງການສົ່ງເງິນຄືນນີ້?',
        dataLeft: 'ຂໍ້ມູນທີ່ເຫລືອ'
    },
    netError: {
        try_again: 'ລອງອີກເທື່ອນຶ່ງ',
        net_error: 'ບໍ່ມີເຄືອຂ່າຍ',
        try_again_desc: 'ກະລຸນາກວດເບິ່ງການຕັ້ງຄ່າເຄືອຂ່າຍແລະລອງໃຫມ່ອີກຄັ້ງ'
    },
    loadFail: {
        try_again: 'ລອງອີກເທື່ອນຶ່ງ',
        load_fail: 'ການໂຫຼດລົ້ມເຫລວ',
        load_fail_desc: 'ການໂຫຼດຂໍ້ມູນລົ້ມເຫລວ, ກະລຸນາລອງໃຫມ່ອີກຄັ້ງ',
        IMEI_Not_Exist: 'IMEI ບໍ່ມີ, ກະລຸນາພະຍາຍາມເຂົ້າຈາກທາງເຂົ້າເບື້ອງຂວາ',
        Project_Not_Exist:'ຂໍ້ຜິດພາດເກີດຂື້ນ. ກະລຸນາຕິດຕໍ່ບໍລິການລູກຄ້າ. (01)', 
        commonError:'ຂໍ້ຜິດພາດເກີດຂື້ນ. ກະລຸນາຕິດຕໍ່ບໍລິການລູກຄ້າ.'
    },
    settlement_Easy_and_convenient:"ງ່າຍແລະສະດວກ",
    settlement_Great_deal:"ທີ່ແຮກ",
    settlement_Safe_and_secure:"ປອດໄພແລະປອດໄພ",
    settlement_Autopay_service_regulation:"ລະບຽບການບໍລິການຈ່າຍອັດຕະໂນມັດ",
    settlement_Read:"ອ່ານ",
    settlement_No_coupon:"ບໍ່ມີຄູປອງທີ່ມີ",
    settlement_Subtotal:"ນິຍາຍ",
    settlement_Coupon:"ຄູປອງ",
    settlement_TOTAL:"ທັງຫມົດ",
    settlement_promotion_tip:"ການສະເຫນີສົ່ງເສີມການໂຄສະນາບໍ່ສາມາດໃຊ້ຮ່ວມກັບຄູປອງໃດໆ",
    settlement_coupon_tip:"ຄູປອງບໍ່ສາມາດໃຊ້ຮ່ວມກັບຂໍ້ສະເຫນີໂປໂມຊັ່ນອື່ນໆ",
    member_myFlow_noList:"ບໍ່ມີຂໍ້ມູນ",
    detail_se_content:"ເປັນວິທີທີ່ປອດໄພ, ງ່າຍແລະສະດວກ. ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ",
    Enter_Promo_code:"ລະຫັດໂປໂມຊັ່ນ",
    Enter_Promo_Coupon:"ຄູປອງ",
    settlement_Not_used_coupon:"ຄູປອງບໍ່ໄດ້ໃຊ້",
    settlement_Available_coupon:"ມີໄວ້",
    settlement_Unavailable_coupon:"ບໍ່ມີເລີຍ",
    please_Enter_Promo_code:"ກະລຸນາໃສ່ລະຫັດໂປໂມຊັ່ນ",
    please_Select_Coupon_use:"ກະລຸນາເລືອກຄູປອງທີ່ທ່ານຕ້ອງການໃຊ້.",
    Buy_Now:"ຊື້ດຽວນີ້",
    Dont_Use_Any:"ຢ່າໃຊ້",
    settlement_confirm:"ຢືນຢັນ",
    settlement_tips:"ຢືນຢັນ",
    flowDetail_unsubscribe: "ຍົກເລີກການສະຫມັກ",
    flowDetail_unsubscribed: "ເຊົາສະໝັກແລ້ວ",
    flowDetail_isCancelPackage: "ຍົກເລີກຊຸດນີ້ບໍ?",
    flowDetail_confirmAgreementUnsubscribe:"ທ່ານບໍ່ສາມາດມີຂໍ້ຕົກລົງທີ່ຍິ່ງໃຫຍ່ຫຼັງຈາກທີ່ສະຫມັກສະມາຊິກ. ທ່ານແນ່ໃຈບໍ່ວ່າທ່ານຕ້ອງການຍົກເລີກການສະຫມັກ?",
    flowDetail_cancel:"ຍົກເລີກ",
    flowDetail_cancelSuccess:"ຍົກເລີກການສະຫນັບສະຫນູນຢ່າງສໍາເລັດຜົນ",
    packages_detail_promotion:"ການສົ່ງເສີມ",
    orderTips:{
        "iDay" : "ວັນ",
        "iDays" : "ມື້",
        "iMonth" : "ເດືອນ",
        "iMonths" : "ເດືອນ້ວ",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol ໃນການຊື້ຄັ້ງທໍາອິດຂອງທ່ານ, ຈ່າຍ %@money/%@periodSymbol ຕໍ່ມາ, ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ",
        'Monthly_discount':"ບັນທຶກ %@saveMoney ແຕ່ລະ %@period! ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ",
        'Ordinary_monthly_package':"ເປັນວິທີທີ່ປອດໄພ, ງ່າຍແລະສະດວກ. ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ",
        "AlreadyPurchased":'ຂໍອະໄພທີ່ທ່ານພຽງແຕ່ສາມາດສະຫມັກສະມາຊິກຫນຶ່ງຊຸດໃນເວລານີ້. ກະລຸນາຍົກເລີກການສະຫມັກຈາກ “%@” ແລະສະຫມັກຫຼັງຈາກນັ້ນກັບຊຸດໃດກໍ່ຕາມທີ່ທ່ານປາດຖະຫນາຫຼັງຈາກມັນຫມົດອາຍຸ.',
        "Contract_recommendation_First":'<label>ດ້ວຍການບໍລິການ Autopay, ໃນການຊື້ຄັ້ງທໍາອິດຂອງທ່ານ, ຈ່າຍເທົ່ານັ້ນ</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ'
        +'<a class="btn">ເລັ່ຍລາຍ ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>ດ້ວຍການບໍລິການ Autopay, ຈ່າຍເທົ່ານັ້ນ</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ'
        +'<a class="btn">ເລັ່ຍລາຍ ></a></p>',
        "Contract_recommendation_General":"<label>ກັບການບໍລິການ Autopay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">ເປັນວິທີທີ່ປອດໄພ, ງ່າຍແລະສະດວກ. ທ່ານສາມາດຍົກເລີກການສະຫມັກໄດ້ທຸກເວລາ'
        +'<a href="javascript:;" class="btn">ເລັ່ຍລາຍ ></a></p>',
        'BanlanceDoubleCheck':'ທ່ານແນ່ໃຈບໍ່ວ່າທ່ານຕ້ອງການຈ່າຍດ້ວຍຄວາມສົມດຸນ?',
    },
    feedback: {
        title: "ຄໍາຄຶດຄໍາເຫັນ",
        placeholder: "ກະລຸນາໃສ່ປະເທດທີ່ທ່ານຕ້ອງການໄປຢ້ຽມຢາມຫຼືຄໍາຖາມອື່ນໆ, ແລະພວກເຮົາຈະຕອບສະຫນອງຄວາມຕ້ອງການຂອງທ່ານໄວເທົ່າທີ່ຈະໄວໄດ້!",
        submit: "ສົ່ງ",
        submit_success: "ສົ່ງສໍາເລັດ",
        other_opinions: "ຄວາມຄິດເຫັນອື່ນໆ"
    },
    view_country_input: 'ກະລຸນາໃສ່ບັນຊີຂອງທ່ານ',
    "select_package": {
        "title": "ເລືອກຂໍ້ມູນ",
        "allPackage": "ຂໍ້ມູນເທັງໝົດ",
        "type": "ປະເພດ",
        "flow": "ຂໍ້ມູນ",
        "month_package": "ແຜນການປະຈຳເດືອນ",
        "flow_package": "ແພັກເກັດຂໍ້ມູນ",
        "time": "ระยะเวลາ",
        "period": "ວົງຈອນ",
        "auto_debit": "ຂໍ້ມູນການຫັກເງິນອັດຕະໂນມັດ",
        "auto_subscribe": "อັດຕະໂນມັດต่ออายุ",
        "detail": "ລາຍລະອຽດຂໍ້ມູນ",
        "carrier": "ບໍລິສັດຜະລິດຕະພັນໄດ້ຮັບການສະໜັບສະໜູນ",
        "country": "ประเทศที่ຄອບຄຸມ",
        "notice": "คู่มือການຊື້"
    }
}